import React from 'react'
import Link, { LINK_SIZES } from 'components/Link'
import MarketInsightLinksBlockListColumnItem from './MarketInsightLinksBlockListColumnItem.jsx'
import PropTypes from 'prop-types';

const MarketInsightLinksBlockListColumn = ({ heading, items }) => (
    <div 
        className='market-insight-links-block__column' 
    >
        {heading && 
            <h3 className='market-insight-links-block__column-heading'>{heading}</h3>
        }
        {items && items.length > 0 ? (
            <ul className='market-insight-links-block__column-list'>
                {items.map((item, index) => (
                    <li className='market-insight-links-block__column-item' key={index}>
                        <Link
                            {...item.link}
                            size={LINK_SIZES.large}
                        />
                    </li>
                ))}
            </ul>
        ) : null}
    </div>
);

MarketInsightLinksBlockListColumn.propTypes = {
    heading: PropTypes.string,
    items: PropTypes.arrayOf(PropTypes.exact(MarketInsightLinksBlockListColumnItem.propTypes))
}

export default MarketInsightLinksBlockListColumn;